




























import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { filterEmpty } from '@acgn/herm/src/util/business';
import { AcgnFormContent, AcgnFormTitle } from '@/components/';
import { namespace } from 'vuex-class';
import { setDateTimeStamp } from '@acgn/herm/src/util/time';
import {
  AcgnSearchWrap,
  AcgnTable,
  AcgnTableButtonGroup,
  AcgnTopButton,
} from '@acgn/herm/src/ui';
const WorkerAction = namespace('desk/worker').Action;
const CommGetter = namespace('desk/comm').Getter;

@Component({
  components: {
    AcgnFormContent,
    AcgnFormTitle,
    AcgnTable
  }
})

/**
 * 项目代办列表组件
 */
export default class AcgnTableTask extends Vue {
  private status: any = 1; // 事项状态
  @Prop({ default: [] }) private data: any[]; // 任务数据
  @Prop({ default: [] }) private projectId: any[]; // 任务数据
  @WorkerAction private projectDetail: any; // 获取漫画项目列表
  @WorkerAction private loadings: any; // 漫画loading
  @CommGetter private attributeData: any; // 公共类型
  // 列表配置
  private tableConfig: any = {
    rowClassName: ({ row }: any) => {
      return `page-table-row ${row.state === 2 ? 'color--danger' : ''}`;
    },
    columns: [
      {
        label: '处理项',
        prop: 'task_name',
        render: (h: any, { row }: any) => (this as any).getTaskTitle(row)
      },
      {
        label: '当前状态',
        prop: 'updata',
        width: '220px',
        render: (h: any, { row }: any) => (this as any).getStadius(row)
      },
      {
        label: '截止时间',
        prop: 'overdue_time',
        render(h: any, { row }: any) {
          return h('span', setDateTimeStamp(row.overdue_time, 'YYYY-MM-DD HH:mm:ss'));
        }
      },
      {
        label: '执行人',
        prop: 'dtalk_real_name'
      },
      {
        label: '操作',
        prop: 'action',
        minWidth: 100,
        fixed: 'right',
        showOverflowTooltip: false,
        render: (h: any, { row, $index }: any) => {
          const btns = [
            {
              icon: `ift-fee`,
              color: '#1195e4',
              text: '去处理',
              type: 'edit',
              disabled: false,
              to: {
                name: 'desk-workerTask',
                params: {
                  id: this.projectId,
                  task_group_id: row.task_group_id,
                  task_id: row.task_id
                }
              },
            }
          ];
          btns.forEach((btn: any) => {
            btn.row = row;
          });
          return h(AcgnTableButtonGroup, {
            props: {
              btns,
            },
            on: {
              click: (item: any) => {
                // this.onListAction(item);
              },
            },
          });
        }
      }
    ],
    data: []
  };

  private pageConfig: any = { // 分页数据
    total: 0,
    currentPage: 1
  };

  private searchForm: any = { // 头部筛选项
    name: '',
    username: ''
  };
  // table组件获取数据更新数据接口
  private async initSearh({ page }: { page: any }) {
    const { tableConfig, pageConfig } = this;
    const options = {
      ...filterEmpty(this.searchForm),
      project_id: this.projectId,
      status: this.status,
    };
    const { result, paging } = await this.projectDetail(options);
    tableConfig.data = result;
    pageConfig.currentPage = paging.page;
    pageConfig.pageSize = paging.size;
    pageConfig.total = paging.total;

    const { page_size, ...args } = options;
    this.$setFormCache({ ...args });
  }

  private getTaskTitle(row: any) {
    return (
      <span>{row.group_name} {row.task_name}  {row.name}</span>
    );
  }

  // 逾期 审批
  private get statusOverdue() {
    return this.attributeData.other_type[1][1].name;
  }

  // 逾期 提交
  private get statusSubmit() {
    return this.attributeData.other_type[2][1].name;
  }

  // 审批状态列表
  private get statusName() {
    return this.attributeData.other_type[0];
  }

  // 获取状态
  private getStadius(row: any) {
    const stadiusSubmitHtml: any =
      row.over_submit_status === 2 ? <span class="acgn-base acgn-refuse">{this.statusOverdue}</span> : '';
    const stadiusApproveHtml: any =
      row.over_approve_status === 2 ? <span class="acgn-base acgn-refuse">{this.statusSubmit}</span> : '';
    const arr = ['acgn-succ', 'acgn-ing', 'acgn-refuse', 'acgn-pass', 'acgn-succ'];
    return (
      <div>
        <span class={['acgn-base', arr[row.status - 1]]}>{this.statusName[row.status - 1].name}</span>
        {stadiusSubmitHtml}{stadiusApproveHtml}
      </div>
    );
  }
}
